import { useNavigate } from "react-router-dom";
import style from "../auth.module.scss";

function AuthLayout({ children }) {
  const navigate = useNavigate(); // Hook for navigation

  const handleLogoClick = () => {
    navigate("/login"); // Navigate to the home page
  };

  return (
    <div className={style["layout-wrapper"]}>
      <div className={style["logo-container"]} onClick={handleLogoClick}>
        <img src="/svg/logo.svg" className="cursor-pointer" alt="logo" />
      </div>
      {children}
    </div>
  );
}

export default AuthLayout;
